import { SHARED_GALLERY } from '../ids';
import { InstallLocation } from '../types';
export const ids = SHARED_GALLERY;
export const getDefinition = (staticsUrl, t) => ({
    ...ids,
    installLocation: InstallLocation.Profile,
    method: 'addSection',
    urlOverride: 'gallery',
    social: true,
    menuOrder: 2,
    page: {
        name: t('gallery_page_name'),
        shortDescription: t('gallery_page_short_description'),
        description: t('gallery_page_description'),
        origin: t('shared_gallery_origin'),
        iconURL: `${staticsUrl}assets/images/icons/shared-gallery-icon.png`,
        screenshots: [
            `${staticsUrl}assets/images/shared-gallery/shared-gallery.png`,
            `${staticsUrl}assets/images/shared-gallery/mobile-shared-gallery.png`,
        ],
    },
});
//# sourceMappingURL=shared-gallery.js.map